var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-alert-badge[data-v-4614b90a]{position:absolute;font-size:var(--font-tiny);font-weight:var(--font-weight-normal);text-transform:none;padding-top:1px;color:var(--always-white);background:transparent url(" + escape(require("../../assets/img/new_badge.png")) + ") no-repeat;background-size:35px 16px;width:23px;height:27px;text-align:center}", ""]);

// exports
